import axios from 'axios'

export default {
	post: async function (image, processingDocumentId, enrollmentId) {
		const request = _prepareRequest(image, processingDocumentId, enrollmentId)
		const response = await axios.post('/api/scan', request.data, request.config)
		return response.data
	}
}

function _prepareRequest (image, processingDocumentId, enrollmentId) {
	const config = {
		headers: { 'Content-Type': 'multipart/form-data' }
	}
	const data = new FormData()
	data.append('processing-document-id', processingDocumentId)
	data.append('enrollment-id', enrollmentId)
	data.append('img', image, image.name)
	return { data, config }
}
